import { useEffect, useState } from 'react';
import constants from '../constants/constants.json';
import axios from 'axios';
import { logError } from '@lib/logger/logError.ts';

interface LatestData {
  connect: string;
}

export const useVersionCheck = ():{hasNewVersion: boolean, newVersion: string, currentVersion: string} => {
  const [hasNewVersion, setHasNewVersion] = useState(false);
  const [newVersion, setNewVersion] = useState<string>('');

  const currentVersion = constants.version;

  useEffect(() => {
    const checkVersion = async (): Promise<void> => {
      try {
        const res = await axios.get<LatestData>(
          'https://raw.githubusercontent.com/tendril-llc/.github/main/versions.json'
        );

        const latest = res.data.connect;
        setNewVersion(latest);

        console.log(`Current version : ${currentVersion} latest version: ${latest} on env`);

        if (isNewerVersion(currentVersion, latest)) {
          setHasNewVersion(true);
        }
      } catch (e) {
        await logError('App version check failed.', 'useVersionCheck', undefined, false);
      }
    };

    void checkVersion().then();
  }, []);

  return { hasNewVersion, newVersion, currentVersion };
};

const isNewerVersion = (oldVer: string, newVer: string): boolean => {
  const oldParts = oldVer.split('.');
  const newParts = newVer.split('.');

  for (let i = 0; i < newParts.length; i++) {
    const a = Number(newParts[i]);
    const b = Number(oldParts[i]);

    if (a > b) {
      return true;
    }
    if (a < b) {
      return false;
    }
  }

  return false;
};